export default __webpack_public_path__ + "static/media/ccfgb_logo-inverted.84d07a4f.svg";